<mat-chip disabled selected [ngClass]="cssClass">{{ label }}</mat-chip>
